import React, { useCallback, useLayoutEffect, useRef, useState } from 'react';
import Button from './../../components/button/button';

const ViewSelector = ({ showViewButtons, displayViewName, handleButtonClick, handleSelect, selectedView,helioDatas }) => {

  const viewListRef = useRef(null);
  const [scrollIndicator, setScrollIndicator] = useState({ height: 100, top: 0 });

  const updateScrollIndicator = useCallback(() => {
    const list = viewListRef.current;
    if (!list || !list.scrollHeight) return;

    const height = Math.min(100, (list.clientHeight / list.scrollHeight) * 100);
    const top = Math.max(0, Math.min(100 - height, (list.scrollTop / list.scrollHeight) * 100));
    setScrollIndicator((previous) => (
      previous.height === height && previous.top === top ? previous : { height, top }
    ));
  }, []);

  useLayoutEffect(() => {
    const list = viewListRef.current;
    if (!showViewButtons || !list) return;

    const selectedButton = list.querySelector('.pdvGrayed');
    if (selectedButton) {
      const listBounds = list.getBoundingClientRect();
      const selectedBounds = selectedButton.getBoundingClientRect();

      if (selectedBounds.bottom > listBounds.bottom) {
        list.scrollTop += selectedBounds.bottom - listBounds.bottom;
      } else if (selectedBounds.top < listBounds.top) {
        list.scrollTop += selectedBounds.top - listBounds.top;
      }
    }

    updateScrollIndicator();
    const resizeObserver = new ResizeObserver(updateScrollIndicator);
    resizeObserver.observe(list);
    return () => resizeObserver.disconnect();
  }, [showViewButtons, selectedView, helioDatas.cameras, updateScrollIndicator]);

  return (
    <div id="viewSelector" className="buttonContainerView">
      <div className="buttonContainerMainView">
        <Button
          customClass={displayViewName ? 'btnPdv' : 'btnPdv'}
          onClick={() => handleButtonClick('view')}
          text={displayViewName ? displayViewName : 'Choisir le point de vue'}
          // icon={'picto-view'}
        />
      </div>
      {showViewButtons && (
        <div className='viewListContainer'>
          <div ref={viewListRef} className='buttonContainerDisplayView' onScroll={updateScrollIndicator}>
            {helioDatas.cameras.map((view) => (
              <Button
                key={view.id}
                onClick={() => handleSelect(view, 'view')}
                text={view.displayName}
                // customClass={view.id === selectedView ? 'test' : 'test'}
                customClass={view.id === selectedView ? 'pdvGrayed' : 'pdvNormal'}
              />
            ))}
          </div>
          {scrollIndicator.height < 100 && (
            <div className='viewListScrollTrack' aria-hidden='true'>
              <div
                className='viewListScrollThumb'
                style={{ height: `${scrollIndicator.height}%`, top: `${scrollIndicator.top}%` }}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ViewSelector;
